import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, matchPath } from 'react-router-dom';
import Header from './components/header';
import Footer from './components/footer';
import { AppFirebase, auth, database } from './config/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { collection, doc, getDoc, getFirestore, limit, onSnapshot, orderBy, query, Timestamp, where } from 'firebase/firestore';
import Logo from './components/images/logo.png';
import AuthPage from './pages/auth';
import 'swiper/css';
import Person from './pages/person';

const Layout = ({ children, noHeaderFooterPaths = [] }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [moviesWatching, setMoviesWatching] = useState([]);

  // Função para verificar se o header e o footer devem ser exibidos
  const shouldHideHeaderFooter = () => noHeaderFooterPaths.some((path) => matchPath(path, location.pathname));
  const showHeaderFooter = !shouldHideHeaderFooter();

  const [movies, setMovies] = useState(null);
  const [moviesPerson, setMoviesPerson] = useState(null);
  const [ getMoviesWatching, setGetMoviesWatching ] = useState(false);
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [account, setAccount] = useState(null);
  const [signature, setSignature] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const [ backgroundNav, setBackgroundNav ] = useState("#202020");
  
  const queryParams = new URLSearchParams(location.search);
  const person = queryParams.get('pessoa');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (authUser) => {
      if (authUser) {
        setUser(authUser);
        setLoadingUser(true);

        const profile_uid = localStorage.getItem('profile_uid');

        // Função para buscar os dados do usuário
        const fetchUserData = async () => {
          try {
            const userRef = doc(database, 'users', authUser.uid);
            const userDoc = await getDoc(userRef);

            if (userDoc.exists()) {
              setUserData(userDoc.data());
            } else {
              console.log('As informações deste usuário não foram encontradas no database.');
            }
          } catch (error) {
            console.error('Erro ao buscar informações do usuário:', error);
          } finally {
            setLoadingUser(false);
          }
        };

        fetchUserData();

        // Função para buscar os dados do perfil, se existir
        if (profile_uid) {
          const fetchProfileData = async () => {
            try {
              const profileRef = doc(database, 'profiles', profile_uid);
              const profileDoc = await getDoc(profileRef);

              if (profileDoc.exists()) {
                console.log('As informações do perfil foram pesquisadas e encontradas no database.');
                setProfile(profileDoc.data());
                fetchAccountData(profileDoc.data()?.account_uid)
              } else {
                console.log('As informações do perfil não foram encontradas no database.');
              }
            } catch (error) {
              console.error('Erro ao buscar informações do perfil:', error);
            }
          };

          fetchProfileData();
        } else {
          console.log('Profile não definido, redirecionando para a página de perfis...');
          navigate('/profiles');
        }
      } else {
        setUser(null);
        setLoadingUser(false);
        console.log('Usuário não está conectado.');
      }
    });

    return () => unsubscribe();
  }, []);

  // Get movies Wathing
  useEffect(() => {
    if (!getMoviesWatching) return;
  
    const database = getFirestore(AppFirebase);
    const profile = localStorage.getItem('profile_uid');
  
    if (!user?.uid || !profile) return;
  
    const timestampDesejado = Timestamp.fromDate(new Date("2025-02-06"));
    const watchingCollection = collection(database, `profiles/${profile}/playlists/watching/movies`);
  
    // Criando a query para buscar os 10 filmes mais recentes
    const q = query(
      watchingCollection,
      where("updated", ">=", timestampDesejado),
      orderBy("updated", "desc"),
      limit(10)
    );

    console.log("Movies watching foi pesquisado às: ", new Date());
  
    // Listener para atualizar os filmes em tempo real
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const arr = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
      const filteredArr = arr.filter(item => item.display !== false);
      setMoviesWatching(filteredArr);
      console.log("movies Watching: ", filteredArr);
    });
  
    return () => unsubscribe(); // Remove o listener ao desmontar o componente
  }, [user, getMoviesWatching]);

  useEffect(()=>{
    console.log("getMoviesWatching status: ", getMoviesWatching ? 'true': 'false');
  }, [ getMoviesWatching ])

  // ocultar o scroll caso o componente 'person' esteja sendo exibido
  useEffect(()=> {
      if (person) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
  }, [ person ]);

  const fetchAccountData = async (uid) => {
    try {
      const accountRef = doc(database, 'users', uid);
      const accountDoc = await getDoc(accountRef);

      if (accountDoc.exists()) {
        setAccount(accountDoc.data());
        fetchSignatureData(uid)
        console.log("Informações da conta foram encontradas no database")
      } else {
        console.log('As informações da conta não foram encontradas no database.');
      }
    } catch (error) {
      console.error('Erro ao buscar informações da conta:', error);
    }
  };

  const fetchSignatureData = async (uid) => {
    try {
      const signatureRef = doc(database, 'members', uid);
      const signatureDoc = await getDoc(signatureRef);

      if (signatureDoc.exists()) {
        setSignature(signatureDoc.data());
        fetchMoviesForSection();
        console.log("Informações da assinatura foram encontradas no database")
      } else {
        console.log('As informações da assinatura não foram encontradas no database.');
      }
    } catch (error) {
      console.error('Erro ao buscar informações da conta:', error);
    }
  };

  // Redireciona para o login se o usuário não estiver autenticado
  useEffect(() => {
    if (!loadingUser && !user?.uid) {
      navigate('/login');
    }
  }, [loadingUser, user, navigate]);
  
  const fetchMoviesForSection = async () => {
    const database = getFirestore(AppFirebase);
    try {
        // Busca o documento único "search/all"
        const docRef = doc(database, "search/all");
        const docSnap = await getDoc(docRef);

        console.log("Todos os filmes foram pesquisados em 'search/all' em: ", new Date())

        if (docSnap.exists()) {
            const data = docSnap.data();
            setMovies(data);
            console.log(data);
            fetchMoviesPerson();
        } else {
            console.error("Documento 'search/all' não encontrado.");
        }
    } catch (error) {
        console.error("Erro ao buscar filmes:", error);
    }
  };

  const fetchMoviesPerson = async () => {
    const database = getFirestore(AppFirebase);
    try {
        // Busca o documento único "search/all"
        const docRef = doc(database, "search/person_movies");
        const docSnap = await getDoc(docRef);

        console.log("Todos os filmes foram pesquisados em 'search/person_movies' em: ", new Date())

        if (docSnap.exists()) {
            const data = docSnap.data();
            setMoviesPerson(data);
            console.log(data)
        } else {
            console.error("Documento 'search/person_movies' não encontrado.");
        }
    } catch (error) {
        console.error("Erro ao buscar filmes:", error);
    }
  };

  return (
    <div>
      {showHeaderFooter && <Header user={user} userData={userData} profile={profile} backgroundNav={backgroundNav} />}
      
      {loadingUser ? (
        <div className="loader-container">
          <img src={Logo} alt="Logo" />
          <div className="loader">
            <div></div>
            <div></div>
          </div>
        </div>
      ) : user?.uid ? (
        <main style={{minHeight: '100dvh'}}>
          {React.Children.map(children, (child) =>
            React.cloneElement(child, { user, userData, account, profile, signature, movies, moviesWatching, setBackgroundNav, setGetMoviesWatching })
          )}
        </main>
      ) : (
        <main style={{ padding: '100px 0', minHeight: '100dvh' }}>
          <AuthPage />
        </main>
      )}

      {showHeaderFooter && <Footer user={user} userData={userData} />}

      {person &&
        <Person person_id={person} movies_person={moviesPerson} all_movies={movies}/>
      }
    </div>
  );
};

export default Layout;
